import React, {} from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineVisibility as Ico } from 'react-icons/md';
// Components
import CommonButton from "../../common/button/button";
// Actions
import * as mainActions from "../../../redux/actions/main";

const ButtonDetail = ({ 
  primaryValue, 
  primaryName,
  config,
  itemNameSingular,
  defaultDetailPathKey = 'detail',
  page = null,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Selectors
  const currentPage = useSelector(state => state.mainReducer.currentPage);
  const breadscrum = useSelector(state => !!state.mainReducer.breadscrum[currentPage] ? state.mainReducer.breadscrum[currentPage] : []);

  let caption = "Veure"
  let onClick = () => {
    const _page = page || currentPage;
    const pathKey = defaultDetailPathKey;
    const path = `${_page}/${pathKey}/${primaryValue}`;
    // Add item to breadscrum
    dispatch(mainActions.setBreadscrum(currentPage, [...breadscrum, { path, pathKey, primaryValue, primaryName, itemNameSingular, }]));
    // Goto
    navigate(`/${path}`);
  };
  let width = "120px";
  let marginLeft = "0px";
  let disabled = false;
  if (!!config) {
    if (config.visible === false) return null;
    caption = config.caption || caption;
    width = config.width || width;
    marginLeft = config.marginLeft || marginLeft;
    if (config.disabled) disabled = true
  }
  return (
    <CommonButton 
      onClick={onClick} 
      style={{
        width,
        marginLeft,
        display: "flex", // Use flexbox to control alignment
        alignItems: "center", // Center icon and text vertically
        justifyContent: "flex-start", // Align icon and text to the left
        gap: "14px", // Add spacing between icon and text
      }}
      disabled={disabled}
    >
      <Ico size={18} />
      <div>{caption}</div>
    </CommonButton>
  );
};

export default ButtonDetail;
